<template>
  <div
    class="cn-tips-section-tabs"
    :class="{
      'cn-tips-section-tabs--closable': currentTab !== null,
      'is-closable': currentTab !== null,
    }"
  >
    <button
      v-show="currentTab !== null"
      class="cn-tips-section-tabs__close-button tab-close"
      @click="currentTab = null"
    >
      <UiIcon name="close" width="24" height="24" />
    </button>
    <UiTabsNew
      v-model="currentTab"
      :tabs="tabs"
      class="cn-tips-section-tabs__tabs"
    >
      <template #tab="{ tab }">
        <span class="cn-tips-section-tabs__tab-header">
          <UiIcon name="alert-circle" width="24" height="24" />
          <span>{{ tab.title }}</span>
        </span>
      </template>
      <template #panel="{ tab }">
        <div
          class="cn-tips-section-tabs__tab-content text-s tab-content"
          v-html="tab.text"
        />
      </template>
    </UiTabsNew>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import UiTabsNew from '@/components/ui/UiTabsNew';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  tabs: {
    title: string;
    text: string;
  }[];
}
defineProps<Props>();

const currentTab = ref<null | number>(null);
</script>

<style lang="scss">
.cn-tips-section-tabs {
  --ab-canyon-tips-section-tabs-color-bg: var(--ab-canyon-color-neutral-light);
  --ab-canyon-tips-section-tabs-buttons-color-text: var(
    --ab-canyon-color-neutral-dark
  );
  --ab-canyon-tips-section-tabs-tab-header-color-text-highlight: var(
    --ab-canyon-color-accent
  );
  --ab-canyon-tips-section-tabs-tab-content-links-color-text: var(
    --ab-canyon-color-dark
  );
  --ab-canyon-tips-section-tabs-tab-content-links-color-text-hover: var(
    --ab-canyon-color-accent
  );

  .p-tabs {
    --tabs_bg-color: var(--ab-canyon-tips-section-tabs-color-bg);
    --tabs__buttons_color: var(
      --ab-canyon-tips-section-tabs-buttons-color-text
    );
  }
  &--closable {
    position: relative;
    .p-tabs {
      --tabs__header_highlight-color: var(
        --ab-canyon-tips-section-tabs-tab-header-color-text-highlight
      );
    }
    .tab-close {
      position: absolute;
      top: 0;
      right: 0;
      color: var(--ab-canyon-color-neutral-dark);
      position: absolute;
    }
    .p-tablist {
      width: calc(100% - 56px);
    }
  }
  &__tab-header {
    line-height: 24px;
    font-size: 18px;
    flex-shrink: 0;
    display: flex;
    &:hover {
      color: var(--ab-canyon-color-accent);
    }

    .cn-icon {
      margin-right: calc(var(--size-base) / 2);
    }
  }
  &__tab-content {
    padding-top: var(--size-4xl);
    padding-right: 15%;
    padding-left: 15%;
    border-color: var(--ab-canyon-color-neutral);
    margin-top: var(--size-3xl);
    color: var(--ab-canyon-color-dark);

    a {
      color: var(--ab-canyon-tips-section-tabs-tab-content-links-color-text);
      text-decoration: underline;
      transition: color 0.2s ease;
      &:hover,
      &:focus {
        color: var(
          --ab-canyon-tips-section-tabs-tab-content-links-color-text-hover
        );
      }
    }
  }
}
</style>
